import { careWorkAreas } from '@vivaporta/work-areas';

// The catch-all profession remains available in the app, without a public industry page.
export const careIndustryAreas = careWorkAreas.filter(area => area.key !== 'weitere-gesundheitsberufe');
export type CareIndustryPageKey = (typeof careIndustryAreas)[number]['key'];
export const careIndustryPageKeys = careIndustryAreas.map(area => area.key);
export const isCareIndustryPageKey = (key: string): key is CareIndustryPageKey =>
  careIndustryAreas.some(area => area.key === key);
